module.exports = __webpack_public_path__ + "static/media/VRED.fa11d602.png";